"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7528],{

/***/ 47528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GlobeHomepageFirstFoldComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-component.scss.js


var StyledGlobeHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emkctlo0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/components/globe-desktop-homepage-first-fold/globe-desktop-homepage-first-fold-component.scss.js


var StyledGlobeDesktopHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uto0a90"
})("width:100%;height:730px;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.globe-text-and-asset-content{padding-right:0px;.full-paragraph-component-wrapper{width:40%;transform:translateY(-84px);}.image-wrapper{width:60%;pointer-events:none;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/components/globe-desktop-homepage-first-fold/globe-desktop-homepage-first-fold-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var GlobeDesktopHomepageFirstFoldComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GlobeDesktopHomepageFirstFoldComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GlobeDesktopHomepageFirstFoldComponent);
    function GlobeDesktopHomepageFirstFoldComponent() {
        (0,_class_call_check/* default */.Z)(this, GlobeDesktopHomepageFirstFoldComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GlobeDesktopHomepageFirstFoldComponent, [
        {
            key: "render",
            value: function render() {
                var height = this.props.height;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGlobeDesktopHomepageFirstFoldComponent, {
                    className: "globe-desktop-homepage-first-fold-component",
                    style: {
                        height: height
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread({
                        contentClassName: "globe-text-and-asset-content"
                    }, this.props))
                });
            }
        }
    ]);
    return GlobeDesktopHomepageFirstFoldComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/components/globe-mobile-homepage-first-fold/globe-mobile-homepage-first-fold-component.scss.js

var StyledGlobeMobileHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekdm42a0"
})(".globe-text-and-asset-content{.image-wrapper{padding-left:0 !important;padding-right:0 !important;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/components/globe-mobile-homepage-first-fold/globe-mobile-homepage-first-fold-component.js




function globe_mobile_homepage_first_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_mobile_homepage_first_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_mobile_homepage_first_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var GlobeMobileHomepageFirstFoldComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GlobeMobileHomepageFirstFoldComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GlobeMobileHomepageFirstFoldComponent);
    function GlobeMobileHomepageFirstFoldComponent() {
        (0,_class_call_check/* default */.Z)(this, GlobeMobileHomepageFirstFoldComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GlobeMobileHomepageFirstFoldComponent, [
        {
            key: "render",
            value: function render() {
                var fullParagraph = this.props.fullParagraph;
                var newFullParagraph = _object_spread_props(globe_mobile_homepage_first_fold_component_object_spread({}, fullParagraph), {
                    body: "",
                    textAlign: "center"
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGlobeMobileHomepageFirstFoldComponent, {
                    className: "globe-mobile-homepage-first-fold-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread_props(globe_mobile_homepage_first_fold_component_object_spread({
                        contentClassName: "globe-text-and-asset-content"
                    }, this.props), {
                        fullParagraph: newFullParagraph
                    }))
                });
            }
        }
    ]);
    return GlobeMobileHomepageFirstFoldComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/default-props.js
var default_props = __webpack_require__(91841);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var getFullParagraph = function() {
    var fullParagraph = default_props/* default.fullParagraph */.Z.fullParagraph;
    return default_props_object_spread_props(default_props_object_spread({}, fullParagraph), {
        title: "<monday-color green>Together.</monday-color> In projects, processes, and success. Wherever you are.",
        body: "monday.com is the Work OS that powers teams to run projects and workflows with confidence.",
        topic: {},
        buttonConfig: {
            buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
            buttonColor: "dodger-blue"
        }
    });
};
var getAssetDefaultProps = function() {
    var asset = default_props/* default.asset */.Z.asset;
    var image = asset.image;
    var newImage = default_props_object_spread_props(default_props_object_spread({}, image), {
        src: "/static/img/segment-layout-default-images/first-fold/globe2.png"
    });
    return default_props_object_spread_props(default_props_object_spread({}, asset), {
        image: newImage
    });
};
/* harmony default export */ var globe_homepage_first_fold_default_props = ({
    fullParagraph: getFullParagraph(),
    asset: getAssetDefaultProps(),
    titleSize: sizes.MD
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-component.js




function globe_homepage_first_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_homepage_first_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_homepage_first_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var GlobeHomepageFirstFoldComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GlobeHomepageFirstFoldComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GlobeHomepageFirstFoldComponent);
    function GlobeHomepageFirstFoldComponent() {
        (0,_class_call_check/* default */.Z)(this, GlobeHomepageFirstFoldComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GlobeHomepageFirstFoldComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGlobeHomepageFirstFoldComponent, {
                    className: "globe-homepage-first-fold-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobeDesktopHomepageFirstFoldComponent, globe_homepage_first_fold_component_object_spread({}, this.props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobeMobileHomepageFirstFoldComponent, globe_homepage_first_fold_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return GlobeHomepageFirstFoldComponent;
}(react.PureComponent);

GlobeHomepageFirstFoldComponent.defaultProps = globe_homepage_first_fold_default_props;


/***/ })

}]);